import { render, staticRenderFns } from "./newOpen3.vue?vue&type=template&id=0c7c4b4d&scoped=true&"
import script from "./newOpen3.vue?vue&type=script&lang=js&"
export * from "./newOpen3.vue?vue&type=script&lang=js&"
import style0 from "./newOpen3.vue?vue&type=style&index=0&id=0c7c4b4d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7c4b4d",
  null
  
)

export default component.exports